/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.authFullChatClient'

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'chat.bsky.actor.deleteAccount',
        'chat.bsky.actor.getStatus',
        'chat.bsky.convo.acceptConvo',
        'chat.bsky.convo.addReaction',
        'chat.bsky.convo.deleteMessageForSelf',
        'chat.bsky.convo.exportAccountData',
        'chat.bsky.convo.getConvo',
        'chat.bsky.convo.getConvoAvailability',
        'chat.bsky.convo.getConvoForMembers',
        'chat.bsky.convo.getConvoMembers',
        'chat.bsky.convo.getLog',
        'chat.bsky.convo.getMessages',
        'chat.bsky.convo.leaveConvo',
        'chat.bsky.convo.listConvoRequests',
        'chat.bsky.convo.listConvos',
        'chat.bsky.convo.lockConvo',
        'chat.bsky.convo.muteConvo',
        'chat.bsky.convo.removeReaction',
        'chat.bsky.convo.sendMessage',
        'chat.bsky.convo.sendMessageBatch',
        'chat.bsky.convo.unlockConvo',
        'chat.bsky.convo.unmuteConvo',
        'chat.bsky.convo.updateAllRead',
        'chat.bsky.convo.updateRead',
        'chat.bsky.group.addMembers',
        'chat.bsky.group.approveJoinRequest',
        'chat.bsky.group.createGroup',
        'chat.bsky.group.createJoinLink',
        'chat.bsky.group.disableJoinLink',
        'chat.bsky.group.editGroup',
        'chat.bsky.group.editJoinLink',
        'chat.bsky.group.enableJoinLink',
        'chat.bsky.group.getJoinLinkPreviews',
        'chat.bsky.group.listJoinRequests',
        'chat.bsky.group.listMutualGroups',
        'chat.bsky.group.rejectJoinRequest',
        'chat.bsky.group.removeMembers',
        'chat.bsky.group.requestJoin',
      ],
    }),
    /*#__PURE__*/ l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: ['chat.bsky.actor.declaration'],
    }),
  ],
  {
    title: 'Full Chat Client (All Conversations)',
    'title:lang': {},
    detail: 'Control of all chat conversations and configuration management.',
    'detail:lang': { en: 'All Chat Conversations' },
  },
)

export { main }
